/**
 *
 * Return the headers required to invoke a web action
 *
 * @param  {string} ims
 *
 * @returns {String} headers
 *
 */
function getHeaders(ims) {
  const headers = {};
  Object.keys(headers).forEach(h => {
    const lowercase = h.toLowerCase();
    if (lowercase !== h) {
      headers[lowercase] = headers[h];
      headers[h] = undefined;
      delete headers[h];
    }
  });
  // set the authorization header and org from the ims props object
  if (ims.org && !headers.authorization) {
    headers.authorization = `Bearer ${ims.token}`;
  }
  if (ims.org && !headers['x-gw-ims-org-id']) {
    headers['x-gw-ims-org-id'] = ims.org;
  }
  return headers;
}

export default getHeaders;
